export const MapPermissionsToForm = (data: any) => {
    return {
        id: data?.id || '',
        name: data?.name || '',
        icon: data?.icon || '',
        slug: data?.slug || '',
        description: data?.description || '',
        application_id: data?.application ? { value: data.application.id, label: data.application.name } : null,
        childrens: data?.childrens ? (typeof data.childrens === 'string' ? data.childrens : JSON.stringify(data.childrens, null, 4)) : '[]'
    };
};

export const MapFormToPermissions = (values: any) => {
    return {
        name: values?.name,
        icon: values?.icon,
        slug: values?.slug,
        description: values?.description,
        application_id: typeof values?.application_id === 'object' ? values?.application_id?.value : values?.application_id,
        childrens: typeof values?.childrens === 'string' ? JSON.parse(values.childrens) : values?.childrens
    };
};
